import React from "react";
import Context from "../../../../../Context";
import Blocker from "../../../../Misc/Blocker";

export default class UserDeatilInterfaces extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      interfaces: {},
      intrfacesActive: [],
    };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    if (!this.props.user["id"]) return;
    this.setState({ pending: true });

    let intrfacesActive = [];
    let result = await this.context.api.q("/admin/member/interface", {
      id: this.props.user["id"],
    });
    if (result !== false) {
      if (result["id"]) result = [result];
      if (Array.isArray(result)) {
        result.forEach((item) => intrfacesActive.push(String(item.id)));
      }
    }

    let interfaces = {};
    result = await this.context.api.q("/admin/interface/list");
    if (result !== false) {
      if (result["id"]) result = [result];
      if (Array.isArray(result)) {
        result.forEach((item) => (interfaces[item.id] = item));
      }
    }

    this.setState({ interfaces, intrfacesActive, pending: false });
  };

  check = async (id, checked) => {
    if (!this.props.user["id"]) return;
    this.setState({ pending: true });

    let result = false;

    if (checked) {
      result = await this.context.api.q("/admin/member/interface/add", {
        interface: id,
        id: this.props.user["id"],
      });
    } else {
      result = await this.context.api.q("/admin/member/interface/delete", {
        interface: id,
        id: this.props.user["id"],
      });
    }
    if (result !== false) {
      this.context.toast("Интерфейс переключен", "success");
      this.load();
    } else {
      this.context.toast("Не удалось переключить интерфейс", "error");
      this.setState({ pending: false });
    }
  };

  save = async (data) => {
    data.id = this.props.user["id"];
    this.props.onPending(true);
    let result = await this.context.api.q("/admin/user/set", data);
    if (result !== false) {
      this.context.toast("Профиль пользователя сохранен", "success");
      this.props.onFinish();
    } else {
      this.context.toast("Не удалось сохранить профиль прользователя", "error");
      this.props.onPending(false);
    }
  };

  render() {
    return (
      <>
        <div>
          <Blocker on={this.state.pending}>
            <div className="px-lg-5">
              {Object.entries(this.state.interfaces).map(([id, item]) => (
                <label key={id} className="checkbox my-4">
                  <input
                    id={id}
                    onChange={(e) => this.check(e.target.id, e.target.checked)}
                    checked={
                      this.state.intrfacesActive.includes(id) ? true : false
                    }
                    type="checkbox"
                    key={id}
                  />
                  <span className="mr-4"></span>
                  {item.name}
                </label>
              ))}
            </div>
          </Blocker>
        </div>
      </>
    );
  }
}
